export const FILTER_TYPE_LABELS: Record<string, string> = {
  positive_theme: 'Positive themes',
  negative_theme: 'Negative themes',
  brand: 'Brand',
  product: 'Product',
  keyword: 'Keyword',
  hashtag: 'Hashtag',
  profile: 'Profile',
  gender: 'Gender',
  race: 'Race',
  age: 'Age',
  location: 'Location',
  // 'default' is intentionally not included here as it doesn't need a label
};

// Map filter types to their parent page
export const FILTER_TYPE_TO_PAGE: Record<string, string> = {
  positive_theme: 'Conversation',
  negative_theme: 'Conversation',
  brand: 'Conversation',
  product: 'Conversation',
  keyword: 'Conversation',
  hashtag: 'Conversation',
  profile: 'People',
  gender: 'People',
  race: 'People',
  age: 'People',
  location: 'People',
  default: 'Performance',
};
